import React, { Fragment, Component } from "react"
import { connect } from "react-redux"
import { bindActionCreators, compose } from "redux"
import { withRouter } from "react-router-dom"

import { isEmpty } from "lodash"
import history from "app/history"

import Modal from "react-modal"
import Button from "./Button"
import FormDropdown from "components/form/dropdown"
import { CUSTOM_MODAL_TYPES } from "constants/modal-types"

import { getClassScheduleById, courseEnrollment } from "store/user/actions"
import { amountFormatter } from "helpers/util"

import ErrorIcon from "assets/icons/error.svg"
import SuccessIcon from "assets/icons/success.svg"
// Import styles
import "styles/components/common/response-modal.scss"
import FormRadio from "../form/radio"
import Annoucement from "assets/images/announcements/annoucement.jpg"
class CustomModal extends Component {
  state = {
    selectedClass: 0,
    customModaltype: "",
    compliancePeriod: "",
  }

  componentDidUpdate(prevProps) {
    const { isOpen: prevIsOpen } = prevProps
    const { isOpen } = this.props

    if (!isOpen && isOpen !== prevIsOpen) {
      this.setState({
        compliancePeriod: "",
      })
    }
  }

  handleViewSchedule = (id) => {
    const { getClassScheduleById } = this.props
    getClassScheduleById(id)
  }

  onSelectClass = (id) => {
    this.setState({ selectedClass: id })
  }

  handleSelect = (data) => {
    const { name, value } = data

    this.setState({
      [name]: value,
    })
  }

  handleClassEnrollment = () => {
    const { courseEnrollment, closeModal } = this.props
    const { selectedClass } = this.state

    if (selectedClass !== 0) {
      let courseEnrollmentData = {
        class: selectedClass,
        action: "free",
      }

      courseEnrollment(courseEnrollmentData)
      closeModal()
    }
  }

  handleModalTypeChange = (value) => {
    this.setState({ customModaltype: value })
  }

  handleResendEmail = () => {
    const { handleModalAction, closeModal } = this.props

    handleModalAction()
    closeModal()
  }

  handleFreeEnrollment = () => {
    const { handleModalAction, closeModal } = this.props
    const { compliancePeriod } = this.state
    handleModalAction(compliancePeriod)
    closeModal()
  }

  renderModal(modalType) {
    const {
      data,
      handleModalAction,
      closeModal,
      school: { schoolData },
      user: { compliancePeriod: compliancePeriodOptions },
      content,
    } = this.props
    const { config: schoolConfig = {} } = schoolData

    const { selectedClass, customModaltype, compliancePeriod } = this.state

    const hasCompliance = schoolConfig?.products?.mcle

    let type = modalType
    if (
      !isEmpty(customModaltype) &&
      modalType === CUSTOM_MODAL_TYPES.SELECT_CLASS
    ) {
      type = customModaltype
    }

    switch (type) {
      case CUSTOM_MODAL_TYPES.TEXT:
        return (
          <>
            <h1
              className="response-modal-header"
              style={{ color: schoolData.primary_color }}
            >
              {data.name}
            </h1>
            <p className="response-modal-message">
              Enrollment is free! You can access all the course materials and
              you can get your certificate right away.
            </p>
            <div className="response-modal-form">
              {hasCompliance && (
                <div className="compliance-container">
                  <p>Select Compliance Period</p>
                  <FormDropdown
                    horizontal
                    name="compliancePeriod"
                    handleChange={this.handleSelect}
                    options={compliancePeriodOptions}
                    value={compliancePeriod}
                    required={true}
                  />
                </div>
              )}
            </div>
            <div className="button-group">
              <Button
                block
                label="Proceed"
                customClassName="response-modal-button"
                disabled={hasCompliance && !compliancePeriod}
                onClick={
                  isEmpty(customModaltype)
                    ? () => handleModalAction(compliancePeriod)
                    : this.handleClassEnrollment
                }
              />
            </div>
          </>
        )
      case CUSTOM_MODAL_TYPES.COMPLETED:
        return <> COMPLETED</>
      case CUSTOM_MODAL_TYPES.RATING:
        return <> RATING</>
      case CUSTOM_MODAL_TYPES.NOT_STUDENT:
        return (
          <Fragment>
            <span className="response-modal-icon">
              <img src={ErrorIcon} alt="FAILED" />
            </span>
            <h2 className={`response-modal-header error`}>Invalid Account</h2>
            <p className="response-modal-message">
              You can't enroll using this account. Please register as a student
              by clicking the Sign Up button.
            </p>
            <div className="button-group">
              <Button label="OK" onClick={closeModal} />
            </div>
          </Fragment>
        )
      case CUSTOM_MODAL_TYPES.VERIFY_EMAIL:
        return (
          <Fragment>
            <span className="response-modal-icon">
              <img src={ErrorIcon} alt="FAILED" />
            </span>
            <h2 className={`response-modal-header error`}>
              Oops! Your email is not yet verified.
            </h2>
            <p className="response-modal-message">
              Please open your email and check for a message with subject:{" "}
              <strong>Apptitude: Email Verification.</strong> If it's not in the
              inbox. please check your spam folder. If there is no such email,
              click the button below.
            </p>
            <div className="button-group">
              <Button label="Resend Email" onClick={this.handleResendEmail} />
            </div>
          </Fragment>
        )
      case CUSTOM_MODAL_TYPES.INC_PROFILE:
        return (
          <Fragment>
            <span className="response-modal-icon">
              <img src={ErrorIcon} alt="FAILED" />
            </span>
            <h2 className={`response-modal-header error`}>
              Incomplete Profile
            </h2>
            <p className="response-modal-message">
              Please complete your profile before you can start.
            </p>
            <div className="button-group">
              <Button label="Cancel" onClick={closeModal} ghost />
              <Button label="Go to your profile" onClick={handleModalAction} />
            </div>
          </Fragment>
        )
      case CUSTOM_MODAL_TYPES.INC_MCLE_PROFILE:
        return (
          <Fragment>
            <span className="response-modal-icon">
              <img src={ErrorIcon} alt="FAILED" />
            </span>
            <h2 className={`response-modal-header error`}>
              Incomplete MCLE Profile
            </h2>
            <p className="response-modal-message">
              Please complete your MCLE profile before you can start with your
              enrollment.
            </p>
            <div className="button-group">
              <Button label="Cancel" onClick={closeModal} ghost />
              <Button
                label="Go to your MCLE profile"
                onClick={handleModalAction}
              />
            </div>
          </Fragment>
        )
      case CUSTOM_MODAL_TYPES.INC_KYC:
        return (
          <>
            <span className="response-modal-icon">
              <img src={ErrorIcon} alt="FAILED" />
            </span>
            <h2 className={`response-modal-header error`}>KYC Not Submitted</h2>
            <p className="response-modal-message">
              Please comply with the KYC requirements in order to continue.
            </p>
            <div className="button-group">
              <Button label="Cancel" onClick={closeModal} ghost />
              <Button label="Proceed with KYC" onClick={handleModalAction} />
            </div>
          </>
        )
      case CUSTOM_MODAL_TYPES.COURSE_ENDED:
        return (
          <>
            <span className="response-modal-icon">
              <img src={ErrorIcon} alt="FAILED" />
            </span>
            <h2 className={`response-modal-header error`}>Course Ended</h2>
            <p className="response-modal-message">
              Course ended last {data.config.date_end}.
            </p>
            <div className="button-group">
              <Button label="OK" onClick={closeModal} />
            </div>
          </>
        )
      case CUSTOM_MODAL_TYPES.COURSE_NOT_OPEN:
        return (
          <>
            <span className="response-modal-icon">
              <img src={ErrorIcon} alt="FAILED" />
            </span>
            <h2 className={`response-modal-header error`}>
              Course is not yet open
            </h2>
            <p className="response-modal-message">
              Course will be accessible on {data.config.date_start}.
            </p>
            <div className="button-group">
              <Button label="OK" onClick={closeModal} />
            </div>
          </>
        )
      case CUSTOM_MODAL_TYPES.NO_CLASS:
        return (
          <>
            <span className="response-modal-icon">
              <img src={ErrorIcon} alt="FAILED" />
            </span>
            <h2 className={`response-modal-header error`}>Oops!</h2>
            <p className="response-modal-message">
              There are no classes available. Please try again later or you may
              contact the school admin at schooladmin@yahoo.com
            </p>
            <div className="button-group">
              <Button label="OK" onClick={closeModal} />
            </div>
          </>
        )
      case CUSTOM_MODAL_TYPES.SELECT_CLASS:
        return (
          <>
            <h2
              className={`response-modal-header`}
              style={{ color: schoolData.primary_color }}
            >
              Select Class
            </h2>
            <div className="schedule-container">
              <div className="titles-wrapper">
                <p className="title">Class Name</p>
                <p className="title">Class Fee</p>
                <p className="title">Schedule</p>
              </div>
              <div className="schedule-list">
                {data.classes?.map((item, i) => (
                  <div className="schedule-item" key={i}>
                    <FormRadio
                      type="radio"
                      name="radio-choices"
                      value={selectedClass}
                      checked={selectedClass === item.id}
                      onChange={() => this.onSelectClass(item.id)}
                      id={item.id}
                      text={item.name}
                    />
                    <p className="fee">
                      {item.fee ? `PHP ${amountFormatter(item.fee)}` : "Free"}
                    </p>
                    <Button
                      label="View Class"
                      outlined
                      onClick={() => this.handleViewSchedule(item.id)}
                    />
                  </div>
                ))}
              </div>
              <Button
                disabled={selectedClass === 0}
                label="Join this class"
                onClick={() =>
                  data?.fee > 0
                    ? history.push(
                        `/course/payment/${data.slug}?class=${selectedClass}`
                      )
                    : this.handleModalTypeChange(CUSTOM_MODAL_TYPES.TEXT)
                }
              />
            </div>
          </>
        )
      case CUSTOM_MODAL_TYPES.ANNOUNCEMENT:
        return (
          <div className="container">
            <span
              className={`header`}
              style={{ color: schoolData.primary_color }}
            >
              ANNOUNCEMENT
            </span>
            <div className="message">
              <div className="body-copy">
                <img
                  className="annoucement-image"
                  src={Annoucement}
                  alt="annoucement"
                  onClick={() => {
                    history.push("/course-bundles")
                    closeModal()
                  }}
                />
              </div>
              <div style={{ textAlign: "center", marginTop: "8px" }}>
                <Button label="Close" onClick={() => closeModal()} />
              </div>
            </div>
          </div>
        )
      case CUSTOM_MODAL_TYPES.ANNOUNCEMENT_NO_BORDER:
        return (
          <div className="container -noborder">
            <img
              className="annoucement-image"
              src={Annoucement}
              alt="annoucement"
              onClick={() => {
                history.push("/course-bundles")
                closeModal()
              }}
            />
          </div>
        )
      case CUSTOM_MODAL_TYPES.ANNOUNCEMENT_TEXT:
        return (
          <div className="container">
            <span
              className={`header`}
              style={{ color: schoolData.primary_color }}
            >
              ANNOUNCEMENT
            </span>
            <div className="message">
              <div className="body-copy">
                <p
                  dangerouslySetInnerHTML={{
                    __html: content,
                  }}
                />
              </div>
            </div>
            <div style={{ textAlign: "center", marginTop: "12px" }}>
              <Button label="Close" onClick={() => closeModal()} />
            </div>
          </div>
        )
      case CUSTOM_MODAL_TYPES.PAY_LATER:
        return (
          <>
            <span className="response-modal-icon">
              <img src={SuccessIcon} alt="SUCCESS" />
            </span>
            <h2 className={`response-modal-header success`}>Enroll for Free</h2>
            <p className="response-modal-message">
              You can access all modules and their contents for free but no
              certificate will be issued unless paid.
            </p>
            <div className="response-modal-form">
              {hasCompliance && (
                <div className="compliance-container">
                  <p>Select Compliance Period</p>
                  <FormDropdown
                    horizontal
                    name="compliancePeriod"
                    handleChange={this.handleSelect}
                    options={compliancePeriodOptions}
                    value={compliancePeriod}
                    required={true}
                  />
                </div>
              )}
            </div>
            <div className="button-group">
              <Button
                block
                label="Proceed"
                customClassName="response-modal-button"
                disabled={hasCompliance && !compliancePeriod}
                onClick={() => this.handleFreeEnrollment()}
              />
            </div>
          </>
        )
      default:
    }
  }
  render() {
    const { isOpen, closeModal, type } = this.props

    return (
      <Modal
        closeTimeoutMS={1000}
        isOpen={isOpen}
        onRequestClose={closeModal}
        contentLabel={type}
        ariaHideApp={false}
        className="response-modal full"
        overlayClassName="response-modal-overlay"
      >
        <Fragment>
          <div className="response-modal-container">
            {this.renderModal(type)}
          </div>
        </Fragment>
      </Modal>
    )
  }
}

const mapStateToProps = (state) => ({
  school: state.schoolReducer,
  user: state.userReducer,
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ getClassScheduleById, courseEnrollment }, dispatch)

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withRouter
)(CustomModal)
